import {Injectable} from '@angular/core';
import {Inject} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {IAppConfig} from '../app-config.interface';
import {APP_CONFIG, ESTIMATE_PATH} from '../app-config.constants';
import { ApiService } from './api.service';
import { map } from 'rxjs/operators';
import {OffMarketHomeEstimatorResponse} from "../classes/interfaces";

@Injectable()
export class HomeEstimatorService {
  constructor(@Inject(APP_CONFIG) private appConfig: IAppConfig, private apiService: ApiService,
              private httpClient: HttpClient) {
  }

  getOffMarketHomeEstimate(id: string): Promise<OffMarketHomeEstimatorResponse> {
    return this.apiService.getRequest<OffMarketHomeEstimatorResponse>(this.appConfig.urls.homeEstimator.offmarket + id + ESTIMATE_PATH)
      .build()
      .pipe(map(result => {
        return result.response;
      })).toPromise();
  }
}

